import { Route } from "@angular/router";
import { PlanosPage } from "./planos.page";

export const PlanosRouter: Route[] = [
  { path: 'planos', component: PlanosPage }
];
